import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-fail',
  templateUrl: './dialog-fail.component.html',
  styleUrls: ['./dialog-fail.component.scss']
})
export class DialogFailComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogFailComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
